import {
  Box,
  Card,
  CardContent,
  Typography,
  CardActions,
  Link,
} from "@mui/material";
import SuppliesBillsStateContent from "../../SuppliesBillsStateContent/SuppliesBillsStateContent";
import { useTranslation } from "react-i18next";
import {
  BillsDataCard,
  BillsTableRow,
  BillsTableRowKeys,
} from "../../../core/models/bills/bills.model";
import { useNavigate } from "react-router-dom";
import EnvirormentContent from "../../EnvirormentContent/EnvirormentContent";
import { useEffect, useState } from "react";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { setBillSelectedToLocalStorage } from "../../../core/services/localStorage/localStorage.service";

export interface BillsCardProps {
  billsTableRows: BillsTableRow[];
  handleClickDonwloadBill: (id: string) => Promise<void>;
  hasIdCups: boolean;
  getIdCups: (codeCup: string) => string | undefined;
  isDownloadLoading: boolean;
}

const BillsCard = ({
  billsTableRows,
  handleClickDonwloadBill,
  hasIdCups,
  getIdCups,
  isDownloadLoading,
}: BillsCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [rowId, setRowId] = useState<string[]>([]);
  useEffect(() => {
    if (!isDownloadLoading) {
      setRowId([]);
    }
  }, [isDownloadLoading]);

  const billsDataCard: BillsDataCard[] = [
    {
      id: "service",
      title: "Servicio",
      cellContent: (row) => (
        <EnvirormentContent service={row.service} variant={"body1"} />
      ),
    },
    {
      id: "socialReason",
      title: "Razón social",
    },
    ...(!hasIdCups
      ? [
          {
            id: "cif",
            title: "CIF",
            fontWeight: "700",
          },
          {
            id: "cups",
            title: "CUPS",
            cellContent: (row: BillsTableRow) => (
              <Link
                fontWeight={700}
                component="button"
                underline="always"
                onClick={() => {
                  setBillSelectedToLocalStorage(row);
                  navigate(
                    `${process.env.REACT_APP_SUPPLIES}/${getIdCups(
                      row.cups,
                    )}?origin=bills`,
                  );
                }}
              >
                {row.cups}
              </Link>
            ),
          },
        ]
      : []),
    {
      id: "period",
      title: "Periodo",
    },
    {
      id: "amount",
      title: "Importe",
      fontWeight: "700",
    },
    {
      id: "emissionDate",
      title: "Emisión",
    },
    {
      id: "state",
      title: "Estado",
      cellContent: (row) => <SuppliesBillsStateContent state={row.state} />,
    },
  ];

  return (
    <Box component="article" sx={{ marginBottom: 5 }}>
      {billsTableRows &&
        billsTableRows.map((row) => (
          <Card key={row.id} sx={{ marginBottom: 2, position: "relative" }}>
            <CardContent
              sx={{
                padding: 2,
                paddingBottom: 0,
                display: "flex",
                columnGap: 2,
                flexDirection: "column",
              }}
            >
              {billsDataCard.map(
                ({ id, title, contentVariant, fontWeight, cellContent }) => {
                  const textContent = row[id as BillsTableRowKeys];
                  return (
                    <Box key={id} marginBottom="16px">
                      {!!title.length && (
                        <Typography
                          variant="caption"
                          component="h4"
                          sx={{ color: "grey.700", marginBottom: "4px" }}
                        >
                          {t(`Tablas.${title}`)}
                        </Typography>
                      )}
                      {cellContent ? (
                        cellContent(row)
                      ) : (
                        <Typography
                          gutterBottom
                          variant={contentVariant || "body1"}
                          component="p"
                          fontWeight={fontWeight || 400}
                        >
                          {textContent}
                        </Typography>
                      )}
                    </Box>
                  );
                },
              )}
            </CardContent>
            <CardActions sx={{ padding: 2 }}>
              <Link
                component="button"
                underline="none"
                onClick={() => {
                  handleClickDonwloadBill(row.id);
                  setRowId((prevRowId) => [...prevRowId, row.id]);
                }}
                variant="button"
                sx={{
                  position: "unset",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="span"
                  aria-hidden="true"
                  className="t-icon-download"
                  sx={{ paddingRight: "10px", fontSize: "21px" }}
                />{" "}
                {t("Facturas Página.Descargar factura")}
              </Link>
            </CardActions>
            {isDownloadLoading && rowId.includes(row.id) && (
              <LoadingComponentComponent
                isLoading={isDownloadLoading}
                opacity={0.5}
              />
            )}
          </Card>
        ))}
    </Box>
  );
};

export default BillsCard;
